import PensionsInfoUdbetalingerView from './PensionsInfoUdbetalingerView';

export default PensionsInfoUdbetalingerView;
